// ErrorBoundaryWrapper.jsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

const ErrorBoundaryWrapper = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <ErrorBoundary locationKey={location.key} navigate={navigate}>
            <div key={location.key}>
                {children}
            </div>
        </ErrorBoundary>
    );
};

export default ErrorBoundaryWrapper;
